import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCartContext } from '../../../context/CartContext';
import HeaderCartPopup from '../HeaderCartPopup/HeaderCartPopup';
import './HeaderMiniCart.scss';

const HeaderMiniCart = () => {
  const { cart, loading, loadCart } = useCartContext();
  const cartLoadedRef = useRef(false);
  
  useEffect(() => {
    // Ładuj koszyk tylko po stronie klienta i tylko raz
    if (typeof window !== 'undefined' && !cartLoadedRef.current) {
      loadCart();
      cartLoadedRef.current = true;
    }
  }, []); // Pusty dependency array - wykonaj tylko raz po mount
  return (
    <div className="header__menu-item header__menu-item_cart">
      <Link to="/checkout/cart">
        <img className="header__cart-pic" src="https://s3.emmezeta.hr/falcon/header-icon-mini-cart.svg" alt="cart" />
        {cart && cart.total_quantity > 0 && (
          <span className="header__cart-counter">{cart.items.length}</span>
        )}
      </Link>
      <HeaderCartPopup cart={cart} loading={loading} />
    </div>
  );
};

export default React.memo(HeaderMiniCart);
